<template>
  <a
    :class="b()"
    :href="content.url"
  >
    <e-picture
      v-if="content.image"
      :class="b('image')"
      :sizes="sizes"
      :srcset="content.image.srcset"
      :fallback="content.image.fallback"
      :alt="content.image.alt"
      :ratio="375 / 234"
      :loading="disableLazyLoading ? 'auto' : 'lazy'"
      height="234"
      width="375"
    />
    <div
      v-else
      :class="b('image')"
    ></div>

    <div :class="b('content')">
      <div :class="b('top-content')">
        <div :class="b('title')">
          {{ content.title ? content.title : content.name }}
        </div>
        <div :class="b('description')">
          {{ content.description }}
        </div>
      </div>
      <span :class="b('link')">
        {{ $t('c-cms-tile.linkTitle') }}
        <e-icon-sprite icon="i-chevron-2--right" />
      </span>
    </div>
  </a>
</template>

<script>
  import eIconSprite from '@/elements/e-icon-sprite.vue';
  import ePicture from '@/elements/e-picture.vue';

  /**
   * Renders a search result tile for CMS pages.
   */
  export default {
    name: 'c-cms-tile',
    components: {
      eIconSprite,
      ePicture,
    },

    // mixins: [],

    props: {
      /**
       * Expects the content for the cms tile.
       *
       * @property {Object} content
       * @property {String} content.title - A title.
       * @property {String} content.description - The description text.
       * @property {String} content.url - A document path.
       * @property {Object} content.image - A image object.
       */
      content: {
        type: Object,
        required: true,
      },

      /**
       * Allows disabling of lazy loading for the current instance to improve LCP.
       */
      disableLazyLoading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        /**
         * @type {Object} Defines the sizes for the e-picture component.
         */
        sizes: {
          0: 287,
          sm: 321,
          md: 215,
          lg: 362,
        },
      };
    },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  @use 'sass:math';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  @use '@/setup/scss/extends' as *;

  .c-cms-tile {
    $this: &;

    display: flex;
    flex-direction: column;
    border: 1px solid variables.$color-grayscale--900;
    color: variables.$color-grayscale--200;

    &:hover,
    &:focus {
      color: variables.$color-grayscale--200;

      #{$this}__link {
        color: variables.$color-primary--1;

        svg path {
          fill: variables.$color-primary--1;
        }
      }
    }

    &__content {
      display: flex;
      flex: 1 0 auto;
      flex-direction: column;
      justify-content: space-between;
      padding: functions.rem(variables.$spacing--25 variables.$spacing--25 variables.$spacing--40);
    }

    &__title {
      @extend %heading-h3;
      @include mixins.font(variables.$font-size--32);
      @include mixins.line-clamp(2, 1.2);

      margin-bottom: 0.3em;
    }

    &__link {
      display: flex;
      align-items: center;
      margin-top: functions.rem(variables.$spacing--15);
      color: variables.$color-primary--2;

      .e-icon-sprite {
        @include mixins.showMoreIcon();

        display: flex;
      }
    }

    &__image {
      background: url('../assets/placeholder/placeholder--file.svg') no-repeat center center
        variables.$color-grayscale--920;
      background-size: 35%;

      &:not(.e-picture) {
        padding-top: math.percentage(math.div(234, 375));
      }

      img {
        width: 100%;
      }
    }
  }
</style>
